import type { FC } from 'react';

import { AuthProvider, TokenProvider } from 'features/auth/components';
import { Mode } from 'features/multi-mode/enums';
import TeamingLogoutNoticePage from 'pages/teaming-notice/TeamingLogoutNoticePage';

export const VrsTeamingLogoutNoticeRoute: FC = () => {
  return (
    <AuthProvider mode={Mode.VRS}>
      <TokenProvider>
        <TeamingLogoutNoticePage />
      </TokenProvider>
    </AuthProvider>
  );
};
